import React from 'react';
import {Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import RowTooltip from './RowTooltip';
import {CHART_GRID_COLOR, SERIES_COLOR} from './chartColors';

// Barra horizontal ranqueada, uma única série. `tooltipFields` permite exibir
// campos extra da linha (ex.: items/qty além de patients) no hover.
export default function HorizontalBarChart({
    data, dataKey, nameKey, color = SERIES_COLOR, height = 280, valueFormatter, tooltipFields,
}) {
    const fields = tooltipFields || [{key: dataKey, label: 'Valor', formatter: valueFormatter}];

    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart data={data} layout="vertical" margin={{top: 4, right: 24, left: 8, bottom: 4}}>
                <CartesianGrid strokeDasharray="3 3" stroke={CHART_GRID_COLOR} horizontal={false}/>
                <XAxis type="number" tick={{fontSize: 12}} allowDecimals={false} tickFormatter={valueFormatter}/>
                <YAxis type="category" dataKey={nameKey} tick={{fontSize: 12}} width={140}/>
                <Tooltip content={<RowTooltip labelKey={nameKey} fields={fields}/>}/>
                <Bar dataKey={dataKey} fill={color} radius={[0, 4, 4, 0]} maxBarSize={28}/>
            </BarChart>
        </ResponsiveContainer>
    );
}
